module.exports = __webpack_public_path__ + "static/media/check-icon-purple.27af9fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/check-icon-purple.svg
// module id = 1780
// module chunks = 0